(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template"]) return;
  try {
    
                      // Get references to the icon_tag and image-here elements
  const iconTags = document.querySelectorAll('.icon_tag');
  const imageHereElements = document.querySelectorAll('.image-here');

  // Check if the number of icon_tags and image-here elements are the same
                      console.log(iconTags.length +"and"+imageHereElements.length);
  if (iconTags.length === imageHereElements.length) {

    // Iterate over the icon_tag elements and assign values to image-here elements
    iconTags.forEach((iconTag, index) => {
      const imageHereElement = imageHereElements[index];


      // Get the value from the icon_tag element
      const iconTagValue = iconTag.innerHTML;

      // Assign the value to the image-here element
      imageHereElement.innerHTML = iconTagValue;
     
    });
     setTimeout(() => {
      document.querySelector(".block-image").remove();
        }, "2000");
  } else {
    console.log('Number of icon_tag elements and image-here elements are different.');
  }

  } catch(e) { console.error(e); }
})();
})();
